module.exports = __webpack_public_path__ + "img/efectivo.325cf5df.png";